import { isStringBase64Encoded, safelyEncodeBase64Url } from '@dev/ee-tools';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect } from 'react-router';
import { push } from 'redux-first-history';
import { ContactsPaths, pathsParams } from '@/services/dictionaries/Paths';
import { ALL_CONTACTS_SEGMENT } from '@/services/constants';

import { SingleContactRouterProps } from './ContactInterface';

const SingleContactRouter = (props: SingleContactRouterProps): JSX.Element => {
    const { match } = props;
    const { contact } = match.params;
    const dispatch = useDispatch();

    const allContactsSegmentPath = ContactsPaths.SingleSegment.replace(
        pathsParams.segmentName,
        safelyEncodeBase64Url(ALL_CONTACTS_SEGMENT)
    );

    useEffect(() => {
        dispatch(
            push({
                pathname: allContactsSegmentPath,
                state: {
                    overlayContact: isStringBase64Encoded(contact) ? contact : safelyEncodeBase64Url(contact),
                },
            } as any)
        );
    }, []);

    return <Redirect to={allContactsSegmentPath} />;
};

export default SingleContactRouter;
